<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a><span>/ {{ 'Damage Code' }}</span>
</div>

<form [formGroup]="filterFormGroup" class="list-damage-code-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Damage Code</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <app-search class="search-bar" [damageCodeSearchTextForm]="filterFormGroup.controls.damageCodeSearchTextForm"></app-search>
    </div>
  </div>
  <app-damage-code-filters [filterFormGroup]="filterFormGroup" [isDamageCodesList]="isDamageCodesList"></app-damage-code-filters>
  <app-damage-code-grid
    [filterFormGroup]="filterFormGroup"
    class="table-container"
    [isDamageCodesList]="isDamageCodesList"></app-damage-code-grid>
</form>
